<template>
  <div class="grid-swiper">
    <van-swipe :stop-propagation="false" indicator-color="white">
      <van-swipe-item v-for="(page, index) in formatData" :key="index">
        <van-grid :border="false" :column-num="4" square>
          <div v-for="item in page" :key="item.id" class="grid-item" @click="onClickItem(item)">
            <div class="image-wrapper">
              <van-image :src="item.pictureUrl" width="100%" height="100%" />
            </div>
            <div class="title">{{ item.name }}</div>
          </div>
        </van-grid>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { Image as VanImage, Swipe, SwipeItem, Grid, GridItem, Toast } from 'vant';
import { isValidHttpUrl } from '@/utils/validate.js';
export default {
  components: {
    [VanImage.name]: VanImage,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem
  },
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  computed: {
    formatData() {
      return this.chunk(this.data, 8);
    }
  },
  methods: {
    chunk(arr, size) {
      var result = [];
      for (var i = 0, len = arr.length; i < len; i += size) {
        result.push(arr.slice(i, i + size));
      }
      return result;
    },
    onClickItem(item) {
      if (item.correlationType === 1) {
        console.log(item.correlationContent);
        this.$router.push({
          name: 'CourseGroup',
          query: { id: item.correlationContent, title: item.correlationContentName }
        });
      } else if (item.correlationType === 2) {
        console.log(item.correlationContent);
        let path = item.correlationContent;
        if (isValidHttpUrl(path)) {
          location.href = path;
        } else {
          Toast('链接有误');
        }
      } else {
        console.log(item.correlationContent);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .grid-swiper {
    // padding: 40px 0;
    padding-top: 40px;
    background: #fff;
    width: 100%;

    .grid-item {
      padding-bottom: 40px;
      width: 25%;
      height: 202px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 8px;
      .image-wrapper {
        width: 120px;
        height: 120px;
      }
      .title {
        width: 80%;
        font-size: 24px;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
      }
    }
  }

  /deep/ .van-swipe {
    height: auto;
  }
  /deep/ .van-swipe__indicator {
    background-color: rgba(15, 71, 193, 0.1) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/course/home/components/grid-swiper.vue